import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '@/api/query-keys'
import { fetchSignalProviderDetail, fetchSignalProviderList } from './signal-provider-list.api'

export function useSignalProviderList() {
  return useQuery({
    queryKey: queryKeys.signalProviders.list(),
    queryFn: fetchSignalProviderList,
  })
}

export function useSignalProviderDetail(platformUserId: string | null, enabled = true) {
  return useQuery({
    queryKey: queryKeys.signalProviders.detail(platformUserId ?? ''),
    queryFn: () => fetchSignalProviderDetail(platformUserId!),
    enabled: enabled && !!platformUserId,
  })
}
